import {inject, Injectable} from '@angular/core';
import {catchError, map, Observable, of, tap} from 'rxjs';
import {DEVICE} from '../../../../../shared/domain/tokens/device.token';
import {BOOKING_REPOSITORY} from '../../domain/tokens/booking.tokens';
import {EVENT_BUS} from '../../../../../shared/domain/tokens/event-bus.token';
import {Booking} from '../../domain/models/booking.model';
import {IBookingUnLockResponse} from '../../domain/interfaces/booking-unlock-response.interface';
import {BookingUnlockedEvent} from '../../../../../shared/application/events/booking/booking-unlocked.event';

@Injectable({providedIn: 'root'})
export class UnlockBookingUseCase {
  private readonly bookingRepository = inject(BOOKING_REPOSITORY);
  private readonly deviceService = inject(DEVICE);
  private readonly eventBus = inject(EVENT_BUS);

  execute(booking: Booking): Observable<void> {
    const device = this.deviceService.getDeviceInfo();

    if (!booking.lockedBy || !device) {
      return of(void 0);
    }

    return this.bookingRepository.unlock({bookingId: booking.id, deviceId: device.id}).pipe(
      map((response: IBookingUnLockResponse) => response.unlocked ?? false),
      catchError(() => of(false)),
      tap(success => this.publishEvent(booking, success)),
      map(() => void 0)
    );
  }

  private publishEvent(booking: Booking, success: boolean): void {
    this.eventBus.publish(new BookingUnlockedEvent(booking.id, success));
  }
}
